import { Component, OnInit, NgZone, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToasterModule, ToasterService, ToasterConfig} from 'angular2-toaster';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { SettingsService } from '../core/settings/settings.service';

declare const gapi: any;
export interface Semuser {
    usuario?: any;
    pass?: any;
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})

export class LoginComponent implements AfterViewInit {
  showLogin: boolean = true;
  showForgot: boolean = false;
  valForm: FormGroup;
  tk: any;
  user : Semuser = {usuario: ""};
  url: string = "https://semtable.appspot.com/";
  // url: string = "https://dev-ome1-stbx-pedido-dot-semtable.appspot.com/";


  private scope = [
              'profile',
              'email',
              'https://www.googleapis.com/auth/cloud-platform',
              'https://www.googleapis.com/auth/datastore'
            ].join(' ');
  private clientId:string = '786494209215-arn6ol7krv48npcrqfvfl9tv7joihjlt.apps.googleusercontent.com';          
  public auth2: any;

  
  public config1 : ToasterConfig = new ToasterConfig({
    positionClass: 'toast-top-center',
    animation: 'fade',
    timeout: 6000
  });

  toasterService: ToasterService;
  checkoutForm;

  constructor(public settings: SettingsService, public formBuilder: FormBuilder, public http: HttpClient, public toasterServices: ToasterService, fb: FormBuilder, private router: Router,   private zone: NgZone) {
      this.tk = this.token();
      this.toasterService = toasterServices;
      this.checkoutForm = this.formBuilder.group({
        id: '',
        pass: ''
      });
  }

  ngOnInit() {
  }

  public googleInit() {
      let that = this;
      gapi.load('auth2', () => {
        that.auth2 = gapi.auth2.init({
          // hosted_domain: 'es.selecta.com',
          client_id: that.clientId,
          scope: that.scope
        });
        that.attachSignin(document.getElementById('googleBtn'));
      });
  }
  public  attachSignin(element) {
    let ref = this; 
    let win = (window as any);
    this.auth2.attachClickHandler(element, {},
    (googleUser) => {
      // console.log('Token || ' + googleUser.getAuthResponse().id_token);
      // console.log('ID: ' + profile.getId());
      // console.log('Name: ' + profile.getName());
      // console.log('Image URL: ' + profile.getImageUrl());
      // console.log('Email: ' + profile.getEmail());
      let profile = googleUser.getBasicProfile();
      let id_token = googleUser.getAuthResponse().id_token;
      if (id_token) {
         localStorage.setItem('id_token', id_token);
         localStorage.setItem('image_url', profile.getImageUrl());
         localStorage.setItem('full_name', profile.getName());
         localStorage.setItem('email', profile.getEmail());
         this.validateUser(profile.getEmail());
         //this.zone.run(() => this.router.navigate(['/dashboard']));

      }
    }, (error) => {
       this.zone.run(() => this.toasterService.pop('error', 'Error de autentificación', JSON.stringify(error.error)));
    });  
  }

  ngAfterViewInit(){
        this.googleInit();
  }

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response ${captchaResponse}:`);
  }

  toggle() {
    this.showForgot = true
    this.showLogin = false
  }

  token(){
    var date = new Date();
    var n = date.getUTCFullYear() * (date.getUTCMonth()+1) * date.getUTCDate();
    return n
  }

  validateUser (email) {
    var ref = this
    this.user.usuario = email.toUpperCase() 
    let headers = new HttpHeaders().set('Content-Type','application/json');
    let params = JSON.stringify(this.user)
    this.http.post<any>(this.url+'semmobile/p/validate_user?semtk='+this.tk, params ,{headers: headers})
          .subscribe(
          data => {
            if (data.status == 'OK') {
              localStorage.setItem('tipo', data.tipo );
              ref.zone.run(() => ref.router.navigate(['/dashboard/inventory']));
            } else {
              localStorage.clear();
              ref.zone.run(() => ref.toasterService.pop('error', 'Error de autentificación', '   Privilegios insuficientes'));
            }
            //console.log(data);
          },
          error => {
              console.log(<any>error);
          }
      );
  }

  onSubmit (customerData) {
    var ref = this
    this.user.usuario = customerData.id
    this.user.pass =customerData.pass
    if (this.user.usuario === ""  || this.user.pass === "") {
      this.toasterService.pop('error', 'Error de autentificación', 'Usuario y contraseña requeridos')
      return false
    }
    let headers = new HttpHeaders().set('Content-Type','application/json');
    let params = JSON.stringify(this.user)
    this.http.post<any>(this.url+'semmobile/p/log_in?semtk='+this.tk, params ,{headers: headers})
          .subscribe(
          data => {
            if (data.status == 'OK') {
              localStorage.setItem('id_token', "#########");
              localStorage.setItem('full_name', data.nombre );
              localStorage.setItem('email', data.email );
              localStorage.setItem('grupo', data.grupo );
              localStorage.setItem('centro', data.centro );
              localStorage.setItem('almacen', data.almacen );
              localStorage.setItem('centro_nombre', data.centro_nombre );
              localStorage.setItem('almacen_nombre', data.almacen_nombre );
              localStorage.setItem('tipo', data.tipo );

              ref.zone.run(() => ref.router.navigate(['/dashboard/pedido']));
            } else {
              localStorage.clear();
              ref.zone.run(() => ref.toasterService.pop('error', 'Error de autentificación', '   Privilegios insuficientes'));
            }
            //console.log(data);
          },
          error => {
              console.log(<any>error);
          }
      );
  }    
}